export const menu = [
  {
    // li标签的内容
    name: '活动介绍',
    // 当前li标签是否选中的标识
    value: '1',
    // 点击当前li标签&#xff0c;要显示的组件
    comp: 'introduce'
  },
  {
    name: '投票区',
    value: '2',
    comp: 'vote'
  },
  {
    name: '排行榜',
    value: '3',
    comp: 'rank'
  }
]
export const categoryData = [
  {
    category: '1',
    value: '高校新生入学教育'
  },
  {
    category: '2',
    value: '高校日常思政教育'
  },
  {
    category: '3',
    value: '大学生职业素养教育'
  },
  {
    category: '4',
    value: '大学生心理健康教育'
  },
  {
    category: '5',
    value: '大学生安全教育'
  }
]



// WEBPACK FOOTER //
// ./src/common/js/data.js